import { fromUnixTime } from 'date-fns';
import React, { FC } from 'react';

import useRonIvitation from './ron-invite-screen-hooks';
import RonInviteScreenScene from './ron-invite-screen-scene';
import { Buffer } from 'buffer';

const RonInviteScreen: FC = () => {
  const {
    t,
    columns,
    onCopyUrl,
    tokensRon,
    scheduleModal,
    setScheduleModal,
    loadingOrder,
    setTokensRon,
    graphOrder,
    isUserInvolved
  } = useRonIvitation();

  const tokenParsed = tokensRon[0]?.token
    ? JSON.parse(Buffer.from(tokensRon[0]?.token.split('.')[1], 'base64').toString())
    : null;

  const handleOpenScheduleModal = (openModal: boolean) => setScheduleModal(openModal);

  return (
    <RonInviteScreenScene
      t={t}
      columns={columns}
      onCopyUrl={onCopyUrl}
      start={tokenParsed && typeof tokenParsed.nbf === 'number' && Number.isFinite(tokenParsed.nbf) ? fromUnixTime(tokenParsed.nbf) : null}
      end={tokenParsed && typeof tokenParsed.exp === 'number' && Number.isFinite(tokenParsed.exp) ? fromUnixTime(tokenParsed.exp) : null}
      date={tokenParsed && typeof tokenParsed.exp === 'number' && Number.isFinite(tokenParsed.exp) ? fromUnixTime(tokenParsed.exp) : null}
      tokens={tokensRon}
      handleOpenScheduleModal={handleOpenScheduleModal}
      scheduleModal={scheduleModal}
      loadingOrder={loadingOrder}
      setTokensRon={setTokensRon}
      graphOrder={graphOrder}
      isUserInvolved={isUserInvolved}
    />
  );
};

export default RonInviteScreen;
